// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__3DBr2","choiceBoxes":"toolbarselects_choiceBoxes__16G6X","simpleField":"toolbarselects_simpleField__2gnKz"};